interface IconProps {
	width: string
	height: string
	name: string
	fill?: string
	stroke?: string
	className?: string
}

export default function Icon({ width, height, name, fill, stroke, className }: IconProps) {
	return (
		<svg
			width={width}
			height={height}
			fill={fill}
			stroke={stroke}
			className={className}
		>
			<use href={`/imgs/sprite.svg#${name}`} />
		</svg>
	)
}
